import { isNil, has } from 'ramda';
import { FormValues } from 'react-form';

export class ValidationService {
    public required(value: any) {
        return !isNil(value);
    }

    public cannotBeEmpty(value: string) {
        return value.trim().length > 0;
    }

    public validateRequiredFieldsExist(requiredFields: string[], values: FormValues) {
        var allFieldsExist = true;
        requiredFields.forEach(fieldName => {
            if (!has(fieldName, values) || isNil(values[fieldName])) {
                allFieldsExist = false;
            }
        });

        return allFieldsExist;
    }
}


// WEBPACK FOOTER //
// ./src/services/validation/ValidationService.tsx